export const STATSIG_PAGE_TYPES = {
  CATEGORY: 'category',
  SEARCH: 'searchresults',
  TAG: 'taggedproduct',
};
